// O'Connell Center Detailed Accessibility Data
export const OCONNELL_CENTER_DATA = {
  venue: {
    name: "Stephen C. O'Connell Center",
    address: "250 Gale Lemerand Dr, Gainesville, FL 32611",
    phone: "352-392-5500",
    capacity: 10500,
    coordinates: { lat: 29.6512, lng: -82.3465 }
  },

  accessibilityZones: [
    {
      id: 'quiet-1',
      name: "North Sensory Room",
      type: "quiet_zone",
      lat: 29.6515,
      lng: -82.3463,
      floor: 1,
      section: "North Concourse",
      capacity: 15,
      current_occupancy: 4,
      energy_level: "low",
      amenities: [
        "noise_canceling_walls",
        "adjustable_lighting",
        "weighted_blankets",
        "fidget_tools",
        "rocking_chairs",
        "no_fluorescent_lighting",
        "white_noise_option"
      ],
      access_instructions: "Enter through Gate A, turn left at first concourse, room is marked with green star symbol",
      staffed: true,
      description: "Designated low-stimulation space for breaks during events"
    },
    {
      id: 'quiet-2',
      name: "South Wellness Suite",
      type: "quiet_zone",
      lat: 29.6509,
      lng: -82.3467,
      floor: 1,
      section: "South Concourse",
      capacity: 20,
      current_occupancy: 12,
      energy_level: "low",
      amenities: [
        "private_pods",
        "meditation_cushions",
        "aromatherapy",
        "compression_vests",
        "visual_schedules",
        "noise_reducing_headphones",
        "calm_down_kits"
      ],
      access_instructions: "Enter through Gate D, turn right, follow blue accessibility signs",
      staffed: true,
      description: "Wellness-focused quiet retreat with sensory regulation tools"
    },
    {
      id: 'quiet-3',
      name: "Family Care Room",
      type: "quiet_zone",
      lat: 29.6513,
      lng: -82.3466,
      floor: 2,
      section: "Upper Concourse West",
      capacity: 10,
      current_occupancy: 3,
      energy_level: "low",
      amenities: [
        "private_nursing_area",
        "adult_changing_table",
        "medication_refrigerator",
        "filtered_water",
        "comfortable_seating",
        "dim_lighting"
      ],
      access_instructions: "Take elevator near Gate B to Level 2, turn left",
      staffed: false,
      description: "Multi-purpose family and medical care space"
    }
  ],

  accessibleSeating: [
    {
      id: 'ada-101',
      name: "Section 101 - Wheelchair Companion",
      type: "accessible_section",
      lat: 29.6511,
      lng: -82.3464,
      energy_level: "medium",
      total_spaces: 12,
      available_spaces: 5,
      amenities: [
        "wheelchair_spaces",
        "companion_seating",
        "wide_aisles",
        "near_restroom",
        "easy_exit_access",
        "lower_noise_level"
      ],
      proximity_to_exits: "Exit A1 - 30 feet, Exit A2 - 45 feet",
      proximity_to_restrooms: "50 feet",
      description: "Premium accessible seating with excellent sightlines"
    },
    {
      id: 'ada-105',
      name: "Section 105 - Wheelchair Accessible",
      type: "accessible_section",
      lat: 29.6512,
      lng: -82.3465,
      energy_level: "medium",
      total_spaces: 10,
      available_spaces: 7,
      amenities: [
        "wheelchair_accessible",
        "transfer_seating",
        "service_animal_area_nearby",
        "accessible_concessions"
      ],
      proximity_to_exits: "Exit B1 - 40 feet",
      proximity_to_restrooms: "80 feet",
      description: "Accessible seating near service animal relief area"
    },
    {
      id: 'sensory-109',
      name: "Section 109 - Sensory-Friendly",
      type: "sensory_friendly",
      lat: 29.6510,
      lng: -82.3466,
      energy_level: "low",
      total_spaces: 25,
      available_spaces: 11,
      amenities: [
        "reduced_crowd_density",
        "lower_ambient_noise",
        "flexible_seating",
        "fidget_friendly",
        "visual_schedules",
        "lower_lighting",
        "quick_exit_to_quiet",
        "autism_trained_staff"
      ],
      proximity_to_exits: "Exit C1 - 25 feet",
      proximity_to_quiet_zones: "South Wellness Suite - 2 minute walk",
      description: "Designated sensory-friendly seating with movement flexibility"
    },
    {
      id: 'ada-201',
      name: "Section 201 - Upper Level",
      type: "accessible_section",
      lat: 29.6513,
      lng: -82.3464,
      energy_level: "high",
      total_spaces: 8,
      available_spaces: 3,
      amenities: [
        "wheelchair_via_elevator",
        "companion_seating",
        "higher_vantage_point"
      ],
      proximity_to_exits: "Exit Upper A - 35 feet",
      notes: "Higher noise level due to proximity to speakers",
      description: "Upper level accessible seating - may be louder"
    }
  ],

  emergencyExits: [
    {
      id: 'exit-a1',
      name: "Exit A1 - North Main",
      type: "emergency_exit",
      lat: 29.6514,
      lng: -82.3462,
      energy_level: "low",
      width: "double_wide",
      accessible: true,
      amenities: [
        "wheelchair_accessible",
        "automatic_doors",
        "well_lit",
        "ramp_available",
        "direct_outdoor_access"
      ],
      leads_to: "North parking lot and shuttle pickup",
      description: "Primary accessible exit with ramped access"
    },
    {
      id: 'exit-b1',
      name: "Exit B1 - East Side",
      type: "emergency_exit",
      lat: 29.6513,
      lng: -82.3463,
      energy_level: "low",
      width: "double_wide",
      accessible: true,
      amenities: [
        "wheelchair_accessible",
        "near_ada_parking",
        "covered_awning"
      ],
      leads_to: "East parking and ADA spots",
      description: "Direct route to accessible parking"
    },
    {
      id: 'exit-c1',
      name: "Exit C1 - South Main",
      type: "emergency_exit",
      lat: 29.6509,
      lng: -82.3467,
      energy_level: "low",
      width: "double_wide",
      accessible: true,
      amenities: [
        "wheelchair_accessible",
        "level_threshold",
        "wide_path"
      ],
      leads_to: "South entrance and campus",
      description: "Main south exit with campus access"
    },
    {
      id: 'exit-d1',
      name: "Exit D1 - West Side",
      type: "emergency_exit",
      lat: 29.6511,
      lng: -82.3468,
      energy_level: "low",
      width: "single_wide",
      accessible: true,
      amenities: [
        "wheelchair_accessible",
        "usually_less_crowded",
        "service_road_access"
      ],
      leads_to: "West service drive",
      description: "Quieter exit route away from main crowd"
    }
  ],

  guestServices: [
    {
      id: 'guest-main',
      name: "Main Guest Services Desk",
      type: "guest_services",
      lat: 29.6512,
      lng: -82.3465,
      floor: 1,
      location: "Main Lobby",
      energy_level: "medium",
      services: [
        "Wheelchair rentals (manual & powered)",
        "Assistive listening devices",
        "Braille programs",
        "Large print materials",
        "Sensory bags (headphones, fidgets, sunglasses)",
        "Visual schedule cards",
        "Lost & found",
        "Medical assistance coordination"
      ],
      amenities: [
        "wheelchair_rentals",
        "assistive_listening",
        "sensory_bags",
        "visual_schedules"
      ],
      staff_trained_in: ["ADA compliance", "Autism awareness", "Crisis de-escalation", "Basic sign language"],
      description: "Primary guest services with comprehensive accessibility support"
    },
    {
      id: 'medical-aid',
      name: "First Aid & Medical Station",
      type: "medical",
      lat: 29.6510,
      lng: -82.3466,
      floor: 1,
      location: "South Concourse",
      energy_level: "low",
      services: [
        "Licensed medical staff",
        "Private exam rooms",
        "Medication storage",
        "Emergency equipment",
        "Quiet recovery area"
      ],
      amenities: [
        "licensed_medical_staff",
        "private_rooms",
        "medication_storage",
        "quiet_recovery"
      ],
      staff_trained_in: ["Emergency response", "Autism/sensory support", "Seizure protocol", "Anxiety/panic assistance"],
      description: "Medical support with understanding of invisible disabilities"
    },
    {
      id: 'family-assist',
      name: "Family Assistance Center",
      type: "family_services",
      lat: 29.6511,
      lng: -82.3467,
      floor: 1,
      location: "West Concourse",
      energy_level: "low",
      services: [
        "Lost child reunification",
        "Stroller parking",
        "Caregiver respite space",
        "PECS communication boards",
        "Neurodiversity trained staff"
      ],
      amenities: [
        "lost_child_services",
        "stroller_parking",
        "caregiver_respite",
        "communication_boards"
      ],
      description: "Family and caregiver support hub"
    }
  ],

  accessibleRestrooms: [
    {
      id: 'restroom-north',
      name: "North Accessible Restroom",
      type: "restroom",
      lat: 29.6514,
      lng: -82.3463,
      floor: 1,
      gender: "all_gender",
      energy_level: "low",
      amenities: [
        "roll_in_shower",
        "adult_changing_table",
        "grab_bars",
        "lower_fixtures",
        "automatic_doors",
        "emergency_call_button",
        "quiet_location"
      ],
      nearest_seating: "Section 101 - 50 feet, Section 102 - 65 feet",
      description: "Fully accessible family restroom with adult changing facilities"
    },
    {
      id: 'restroom-south',
      name: "South Accessible Restroom",
      type: "restroom",
      lat: 29.6509,
      lng: -82.3467,
      floor: 1,
      gender: "all_gender",
      energy_level: "low",
      amenities: [
        "adult_changing_table",
        "grab_bars",
        "lower_fixtures",
        "wide_stalls",
        "emergency_call"
      ],
      nearest_seating: "Section 109 - 60 feet, Section 108 - 70 feet",
      description: "Accessible restroom near sensory-friendly seating"
    }
  ],

  sensoryZones: [
    {
      area: "Main Court (Center)",
      lat: 29.6512,
      lng: -82.3465,
      energy_level: "high",
      triggers: [
        "Very loud music (90-105 dB)",
        "Bright spotlights & strobes",
        "Crowd noise peaks",
        "Sudden cannon fire",
        "Confetti/streamers"
      ],
      recommendations: "Consider sensory-friendly seating in Section 109 or use quiet zones"
    },
    {
      area: "Student Section (East)",
      lat: 29.6513,
      lng: -82.3464,
      energy_level: "high",
      triggers: [
        "Extreme crowd noise (100+ dB)",
        "Constant standing/movement",
        "Chanting and stomping",
        "Air horns",
        "Dense crowding"
      ],
      recommendations: "Avoid if sensitive to crowds or loud noise"
    },
    {
      area: "Main Concourse",
      lat: 29.6512,
      lng: -82.3466,
      energy_level: "medium",
      triggers: [
        "Moderate crowd noise",
        "Food smells",
        "Music from speakers",
        "Line congestion",
        "Fluorescent lighting"
      ],
      recommendations: "Use during off-peak times; quieter 30+ minutes before event"
    }
  ],

  unseenDisabilitiesSupport: [
    { icon: "∞", label: "Neurodiversity Support", color: "#1e40af" },
    { icon: "🌊", label: "PTSD/Anxiety Zone - Low Stimulus", color: "#0ea5e9" },
    { icon: "🪑", label: "Chronic Illness Rest", color: "#22c55e" },
    { icon: "🌻", label: "Sunflower Lanyard - Hidden Disability", color: "#eab308" }
  ],

  communicationSupport: [
    { name: "ASL Interpreter Services", contact: "ada@ufl.edu or 352-392-1261", note: "48hr advance notice" },
    { name: "PECS Communication Boards", locations: "Guest Services, Family Center, Quiet Zones" },
    { name: "Visual Event Schedules", locations: "Quiet zones, Sensory seating, Guest services" }
  ],

  preparationResources: {
    virtualTour: "https://virtualvenue.ufl.edu/oconnell",
    socialNarrative: "https://accessibility.ufl.edu/oconnell-social-story",
    advanceVisit: "Schedule quiet venue walkthrough before event day"
  }
};

// Helper to get all locations for the map
export function getAllOConnellLocations() {
  const data = OCONNELL_CENTER_DATA;
  const locations = [];
  
  // Add quiet zones
  data.accessibilityZones.forEach(zone => {
    locations.push({
      id: zone.id,
      name: zone.name,
      type: zone.type,
      lat: zone.lat,
      lng: zone.lng,
      description: zone.description,
      energy_level: zone.energy_level,
      capacity: zone.capacity,
      current_occupancy: zone.current_occupancy,
      amenities: zone.amenities,
      access_instructions: zone.access_instructions
    });
  });
  
  // Add accessible seating
  data.accessibleSeating.forEach(seat => {
    locations.push({
      id: seat.id,
      name: seat.name,
      type: seat.type,
      lat: seat.lat,
      lng: seat.lng,
      description: seat.description,
      energy_level: seat.energy_level,
      capacity: seat.total_spaces,
      current_occupancy: seat.total_spaces - seat.available_spaces,
      amenities: seat.amenities
    });
  });
  
  // Add emergency exits
  data.emergencyExits.forEach(exit => {
    locations.push({
      id: exit.id,
      name: exit.name,
      type: exit.type,
      lat: exit.lat,
      lng: exit.lng,
      description: exit.description,
      energy_level: exit.energy_level,
      amenities: exit.amenities,
      leads_to: exit.leads_to
    });
  });
  
  // Add guest services
  data.guestServices.forEach(service => {
    locations.push({
      id: service.id,
      name: service.name,
      type: service.type,
      lat: service.lat,
      lng: service.lng,
      description: service.description,
      energy_level: service.energy_level,
      amenities: service.amenities,
      services: service.services
    });
  });
  
  // Add restrooms
  data.accessibleRestrooms.forEach(restroom => {
    locations.push({
      id: restroom.id,
      name: restroom.name,
      type: restroom.type,
      lat: restroom.lat,
      lng: restroom.lng,
      description: restroom.description,
      energy_level: restroom.energy_level,
      amenities: restroom.amenities
    });
  });
  
  return locations;
}
